import type { ModuleId } from '../core/types';
import type { ModuleInfo } from './runtime';

export const MODULE_INFO: Readonly<Record<ModuleId, ModuleInfo>> = {
  'read-switch': {
    id: 'read-switch',
    label: '2回の動きの向きを見分ける',
    shortLabel: 'ドット面のぼやけた波を答える',
    description: '色が切り替わるドット面に短く現れる、ぼやけた波の2回の動きを答えます。',
    evidenceLabel: '動きを素早く見分ける課題',
    durationLabel: '約3分',
    primaryAction: '画面の2択ボタン',
  },
  'central-peripheral': {
    id: 'central-peripheral',
    label: '車種と周辺標識を同時に見分ける',
    shortLabel: '中央と周辺を2段階で答える',
    description: '中央の車種と、周辺に一瞬出る標識の位置を続けて答えます。',
    evidenceLabel: '中央・周辺の同時判断課題',
    durationLabel: '約2分',
    primaryAction: '車種と位置を画面で選択',
  },
  'player-track': {
    id: 'player-track',
    label: '動く8個の中から4個を追い続ける',
    shortLabel: '4個を同時に追う',
    description: '最初に表示される4個を、同じ見た目の8個が動く中で追います。',
    evidenceLabel: '複数対象追跡課題',
    durationLabel: '約3分',
    primaryAction: '停止した点を直接選択',
  },
  'moving-target': {
    id: 'moving-target',
    label: '動く記号の見分け',
    shortLabel: '輪の切れ目を答える',
    description: '難易度に応じた速さで動く輪の切れ目が、どちらを向くか答えます。',
    evidenceLabel: '動くものを見る課題',
    durationLabel: '約2分',
    primaryAction: '4方向の画面ボタン',
  },
} as const;
